import { useSupportedBookingSoftware } from '@frontend/api-ai-settings';
import { useAppScopeStore } from '@frontend/scope';
import { useAiSettingsAccess } from './use-has-ai-settings-access';

export const useAiScheduleAccess = () => {
  const { selectedLocationIds, selectedOrgId } = useAppScopeStore();
  const locationId = selectedLocationIds[0] ?? '';

  const { hasAiSettingsAccess } = useAiSettingsAccess();

  const { hasSupportedBookingSoftware } = useSupportedBookingSoftware({
    locationId: locationId,
    orgId: selectedOrgId,
  });

  return {
    hasAiScheduleAccess: hasSupportedBookingSoftware && hasAiSettingsAccess,
  };
};
